<template>
<div>
    <a :href="item.clickUrl" v-for="item in data" :data-scp="'product.'+$index" :data-trace-id="item.traceId">
        <div class="marginb20 paddingb20 paddingh20 borderb border-radius flex-container vfull" style="overflow: hidden">
            <div class="pos-r border-radius" style="min-width:100px;height:100px;overflow: hidden;">
                <img alt="" width="100" height="100" onerror="this.src='//image1.51tiangou.com/tgou2/img2/dum/dum_dog.png'" :src="item.imageUrl">
                <div class="pos-a bottom0 left0 text-white" style="font-size: 8px;background: #BDA28B;padding: 3px;" v-show="!(item.source==4&&item.international==1&&item.storeType==3)">
                    <span class="text-limit1 lh-1" v-text="getStoreNameByItem(item)"></span>
                </div>
            </div>
            <div class="flex1 paddingh20 paddingt10 flex-container-col">
                <div style="width:100%">
                    <!-- badge颜色  专柜/bg-bule 云专柜/bg-green2 品牌/bg-orange 超市/bg-green 自营/bg-red  -->
                    <div class="text-fixed2 fs-13 text-darker">
                        <!-- <span class="border-radius fs-10 text-white marginr10" style="padding:0px 2px"
                              v-text="getTagByItem(item).text"
                              :class="getTagByItem(item).className"></span> -->
                        <img :src="getTagByItem(item).imgUrl" alt="" height="16px">
                        <strong>{{item.title}}</strong>
                    </div>
                    <div class="margint10" style="height: 21px;overflow: hidden;">
                        <div class="text-red text-limit1 ribbon_next marginr10" v-for="inner in item.couponList"><div class="float-left" style="padding:3px 0"><span>{{inner}}</span></div></div>
                    </div>
                </div>
                <div class="flex-container bottom" style="width:100%">
                    <template v-if="(showNewPrice && item.newPrice)||item.groupPrice">
                        <div class="flex-container left center" v-if="showNewPrice && item.newPrice">
                            <span class="fs-11 text-red">新人价</span>
                            <span class="text-red fs-19 text-right">¥{{item.newPrice}}</span>
                            <del class="text-light fs-11 marginl10 lh-16">{{item.originalPrice}}</del>
                        </div>
                        <div class="flex-container left center" v-else v-if="item.groupPrice">
                            <span class="fs-11 text-red">拼团价</span>
                            <span class="flex1 text-red fs-19 text-right">¥{{item.groupPrice}}</span>
                            <span class="fs-11 text-darker marginl10">单买价{{item.price}}</span>
                        </div>
                    </template>
                    <div class="flex-container left center" v-else>
                        <span class="flex1 text-red fs-19 text-right">¥{{item.buyoutPrice||item.price}}</span>
                        <del class="text-light fs-11 marginl10 lh-16">{{item.originalPrice}}</del>
                    </div>
                </div>
            </div>
        </div>
    </a>
</div>
</template>

<script>
import $ from 'jquery';
import maple from 'maple';
import mixin from "javascript/libs/tg/pageComponent/index/mixin.js";
import itemService from 'javascript/libs/tg/api/item.js';
export default {
    props:{
        similar:{
            type:Boolean,
            default:true
        },
        data:{type:Array,default:[]},
        showNewPrice:{ //显示新人价
            type: Boolean,
            default:false
        }
    },
    mixins:[mixin],
    methods: {
        changToSame(item,index){
            let vm=this;
            itemService.similar({
                data:{
                    itemId:item.id
                },
                success(data){
                    let scp=`${maple.pageIns.page}.findSimilar.${index}.`+Math.random().toString(36).slice(2,7);
                    _tgs.trackSCP({scp});
                    if(_.get(data,'length')>1){
                        maple.pageIns.changePage(item.sameClickUrl,{
                            scp
                        });
                    }else{
                        maple.notice('没有相似的商品','parking_info');
                        vm.$set('data['+index+'].showSame',false);
                    }
                }
            })
        },
        showSame(item){
            if(!this.similar){
                return false;
            }else{
                if(item.showSame===undefined){
                    return true;
                }else{
                    return item.showSame
                }
            }
        }
    }
}
</script>

<style lang="scss">
    .ribbon_next {
        display: inline-block;
        position: relative;
        height: 19px;
        min-width: 28px;
        border-radius: 0;
        padding: 0;
        background: #fff6f6;
        font-size: 10px;
        text-align: center;
        vertical-align: middle;
        white-space: nowrap;
        overflow: hidden;
    }
    .ribbon_next span{
        border: 1px solid #ffa4a2;
        padding: 2px 5px;
        line-height: 1;
    }
    .ribbon_next:before,
    .ribbon_next:after {
        position: absolute;
        top: 0;
        bottom: 0;
        height: 6px;
        width: 6px;
        border-radius: 50%;
        background: #fff;
        margin: auto;
        content: "";
        border: 1px solid #ffa4a2;
    }
    .ribbon_next:before {
        left: -3px;
    }

    .ribbon_next:after {
        right: -3px;
    }
    .bg-green2{
        background: #16cc90;
    }
    .bg-green{
        background-color: #06B621;
    }

    /* 品牌旗舰店 */
    .badegBackground-1{
	    background-image: linear-gradient(134deg, #3023AE 0%, #C86DD7 100%);
    }

    /* 自营海外购 */
    .badegBackground-2{
	    background: #FF2238 !important;
    }

    /* 商场专柜 商场门店 */
    .badegBackground-3{
	    background-image: linear-gradient(135deg, #FFA600 0%, #FF6D00 100%);
    }
    /* 超市优选 */
    .badegBackground-4{
	    background-image: linear-gradient(133deg, #16CC90 0%, #007C2F 100%);
    }
    /* 自营旗舰店 */
    .badegBackground-5{
	    background-image: linear-gradient(134deg, #004ACB 0%, #32C5FF 100%);
    }
</style>